module.exports = __webpack_public_path__ + "img/update--video-frame--sp.4cb26459.png";